import { render } from "./LoadProject.vue?vue&type=template&id=4f51d67f&ts=true"
import script from "./LoadProject.vue?vue&type=script&lang=ts"
export * from "./LoadProject.vue?vue&type=script&lang=ts"

import "./LoadProject.vue?vue&type=style&index=0&id=4f51d67f&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__